import React from 'react';

const BackdropSection = (props) => (
    <div className="memberbackdrop" onClick={props.click}/>
);

export default BackdropSection;